module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recoverPassword container-fluid"
  }, [_c('b-alert', {
    attrs: {
      "show": _vm.errorAlertShown,
      "dismissible": "",
      "variant": "danger"
    },
    on: {
      "dismissed": function($event) {
        _vm.errorAlertShown = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('LNG_ERROR_SENDING_NEW_PASSWORD', this.lang)))])]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "show": _vm.showSuccess,
      "dismissible": "",
      "variant": "evaobj"
    },
    on: {
      "dismissed": function($event) {
        _vm.showSuccess = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('LNG_NEW_PASSWORD_SENT', this.lang)))])]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.recoverPassword
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('img', {
    attrs: {
      "title": _vm.$t('LNG_TITLE', this.lang),
      "alt": _vm.$t('LNG_TITLE', this.lang),
      "width": "200px",
      "src": require("../assets/img/logo.jpg")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('LNG_TITLE_RECOVER_PASSWORD', _vm.lang)))])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-1"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-input-group', [_c('b-input-group-text', {
    attrs: {
      "slot": "prepend"
    },
    slot: "prepend"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": _vm.$t('LNG_EMAIL', _vm.lang),
      "required": "",
      "autofocus": "",
      "autocapitalize": "off"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "my-3"
  }, [_c('b-col', {
    attrs: {
      "sm": "3",
      "lg": "4"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "sm": "6",
      "lg": "4"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_RECOVER_PASSWORD', _vm.lang)))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecfcb0a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recoverPassword.vue
// module id = 885
// module chunks = 1